import { Button } from "antd";
import { CustomModal } from "../common/CustomModal";
import * as React from "react";
import { Layout, Input, Select } from "antd";
import { Formik } from "formik";
import { listAllDropDownCourse } from "../../Graphs/Course/listAllDropDownCourse";
import { checkPermission } from "../AdminUser/CheckAdminPermission";

const { TextArea } = Input;
const { Content } = Layout;
const Option = Select.Option;

export class AddFaq extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      data: [],
      view: false,
      isLoading: false,
      visible: false,
      selectedCourseType: "",
      errors: {
        selectedCourseType: "",
      },
    };
  }

  input;
  allCourses = [];

  async componentDidMount() {
    const { authToken, course_id } = this.props;

    let courseData = await listAllDropDownCourse(authToken, 0, 1000000);

    if (courseData.data && courseData.data.length >= 1) {
      courseData.data.map((data, index) => {
        this.allCourses.push(<Option value={data._id}>{data.name}</Option>);
      });
    }

    if (course_id) {
      this.setState({ selectedCourseType: course_id });
    }
  }

  validateForm = (values) => {
    const { selectedCourseType } = this.state;

    const errors = {};
    console.log("Validating form -- ", values);

    if (!values.question) {
      errors.question = "Question is required";
    }

    if (!values.answer) {
      errors.answer = "Answer is required";
    }

    if (!selectedCourseType) {
      errors.selectedCourseType = "Please select course";
    }

    console.log("Validating errors -- ", errors);
    return errors;
  };

  handleSubmit = (values, action) => {
    const { selectedCourseType } = this.state;

    // values.FAQs = [{ question: values.question, answer: values.answer }];
    values.question = values.question;
    values.answer = values.answer;
    values.course_id = selectedCourseType;

    this.props.onSubmit(values);

    this.setState({
      visible: false,
    });
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };

  // changeCourse = (value) => {
  //   this.setState({
  //     selectedCourseType: value,
  //   });
  // };

  render() {
    const { primaryColor, loginData } = this.props;
    const canEdit = checkPermission(loginData, "users", "create");
    // console.log(canEdit)
    const { selectedCourseType } = this.state;

    return (
      <div>
        {canEdit && (
        <div
          onClick={this.showModal}
          style={{
            width: "100px",
            backgroundColor: primaryColor,
            color: "white",
            padding: "7px 0px",
            textAlign: "center",
            borderRadius: "50px",
          }}
        >
          ADD
        </div>

        )}

        <CustomModal
          destroyOnClose={true}
          title="Add Faq"
          visible={this.state.visible}
          onCancel={this.handleCancel}
          footer={null}
          maskClosable={false}
        >
          <Content style={{ background: "#fff", marginLeft: "10px" }}>
            <Formik
              initialValues={{
                question: "",
                answer: "",
              }}
              validate={this.validateForm}
              onSubmit={this.handleSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                setFieldTouched,
                isSubmitting,
              }) => {
                return (
                  <div>
                    <div className="formik-field_wrap">
                      <div className="formik-field_wrap">
                        <div className="formik-field-left">
                          Question
                          <Input
                            id="question"
                            placeholder="Question"
                            value={values.question}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.question && touched.question ? (
                            <p
                              style={{
                                color: "red",
                                fontSize: "small",
                                margin: "0",
                              }}
                            >
                              {errors.question}
                            </p>
                          ) : null}
                        </div>

                        <div className="formik-field-right">
                          Course
                          <Select
                            allowClear
                            style={{ width: "100%" }}
                            placeholder="Select Course"
                            showSearch
                            disabled
                            value={selectedCourseType}
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {this.allCourses}
                          </Select>
                          {errors.selectedCourseType ? (
                            <p
                              style={{
                                color: "red",
                                fontSize: "small",
                                margin: "0",
                              }}
                            >
                              {errors.selectedCourseType}
                            </p>
                          ) : null}
                        </div>
                      </div>

                      <div className="formik-field_wrap">
                        <div className="formik-field">
                          Answer
                          <TextArea
                            row={4}
                            id="answer"
                            placeholder="Answer"
                            value={values.answer}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.answer && touched.answer ? (
                            <p
                              style={{
                                color: "red",
                                fontSize: "small",
                                margin: "0",
                              }}
                            >
                              {errors.answer}
                            </p>
                          ) : null}
                        </div>
                      </div>

                      <Button
                        type="primary"
                        style={{
                          marginTop: "19px",
                          background: "#5C6AC4",
                          color: "#fff",
                        }}
                        onClick={handleSubmit}
                      >
                        Add
                      </Button>
                    </div>
                  </div>
                );
              }}
            </Formik>
          </Content>
        </CustomModal>
      </div>
    );
  }
}
